export const ARTICLES = [
  {
    id: "stuck-in-1998",
    title: "Why Recovery Wear Looked Stuck in 1998",
    category: "Behind the Brand",
    date: "Jul 2026",
    excerpt:
      "Beige velcro, hospital plastic, and designs that whisper 'injured.' A physiotherapist on how recovery gear froze in time — and why nobody bothered to fix it.",
    body: [
      "Walk into any clinic supply room and you'll find the same braces that were there thirty years ago. Same velcro, same plastic stays, same shade of sadness. The industry optimized for function and stopped there — as if the person wearing it stopped mattering the moment it 'worked.'",
      "Here's what I saw from the treatment table: people would wear their brace religiously for two weeks, then start 'forgetting' it. Not because it hurt. Because it announced them. It turned a knee into a headline.",
      "LIGATEN exists because that trade-off was always optional. Support can be engineered and beautiful at the same time — the same way running shoes stopped looking like medical devices decades ago. Recovery wear simply never got its redesign. Until now.",
    ],
  },
  {
    id: "movement-is-medicine",
    title: "Movement Is the Medicine — Gently",
    category: "Recovery Notes",
    date: "Jul 2026",
    excerpt:
      "Rest is not a strategy. Why the best recoveries are built on small, consistent movement — and how to find your floor before you find your ceiling.",
    body: [
      "The old instruction was rest until it stops hurting. The new evidence says something kinder and harder: move, a little, early, and often. Tissues remodel under load — gentle, graded, boring, consistent load.",
      "Start with your floor, not your ceiling. Ten slow squats to a chair. A walk around the block that ends before it aches. The win isn't intensity; it's showing up again tomorrow without a setback tonight.",
      "Support wear fits into this as a confidence layer, not a crutch. It lets you move through the wobbly weeks with a little more trust in the joint — and trust, it turns out, is half of rehab.",
    ],
  },
  {
    id: "landing-on-mocha",
    title: "Behind the Shade: How We Landed on Mocha",
    category: "Design",
    date: "Jul 2026",
    excerpt:
      "Sixty swatches, four months, one shade family. The story of how coffee, interiors, and an argument about taupe defined the LIGATEN palette.",
    body: [
      "We started with a simple constraint: if it looks good in a gym but wrong in a café, it's out. Recovery wear lives in both places — so the palette had to belong to lifestyle, not to clinics.",
      "Mocha won because it does something no medical beige ever could: it flatters. On every skin tone, in every light, next to every wardrobe neutral. Taupe and beige joined as the quieter siblings — shades that soften instead of announce.",
      "Sixty swatches later, the rule held. Warm, grounded, calm. The kind of colors that make support feel like a choice you made, not a sentence you're serving.",
    ],
  },
];
